import { render, staticRenderFns } from "./MyAccreditations.vue?vue&type=template&id=e2fb3448&"
import script from "./MyAccreditations.ts?vue&type=script&lang=ts&"
export * from "./MyAccreditations.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports